module.exports = __webpack_public_path__ + "assets/img/teacher (49).af39cc69.png";